import { render, staticRenderFns } from "./movies-add-or-update.vue?vue&type=template&id=5dc576c7"
import script from "./movies-add-or-update.vue?vue&type=script&lang=js"
export * from "./movies-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./movies-add-or-update.vue?vue&type=style&index=0&id=5dc576c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports